import { useParams } from "react-router-dom";
import ProductNavBar from "./ProductNavbar";
import ProductHero from "./ProductHero";
import ProductBenefits from "./ProductBenefits";
import ProductWorkflow from "./ProductWorkflow";
import Footer from "../Footer";
import DownloadSection from "../DownloadSection";
import ProductFaqs from "./ProductFaqs";
import { productsInformation } from "../../../constants/landingConstants";

const ProductPage = () => {
  const { productName } = useParams();

  const product = productsInformation[productName];

  return (
    <div className="bg-white dark:bg-defaultBlack">
      <ProductNavBar />
      <ProductHero product={product} productName={productName} />
      <ProductBenefits product={product} productName={productName} />
      <ProductWorkflow product={product} productName={productName} />
      <ProductFaqs product={product} productName={productName} />
      <DownloadSection />
      <Footer />
    </div>
  );
};

export default ProductPage;
